import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Button, Form, Input, message } from 'antd';
import { graphql, compose } from 'react-apollo';
import validationRegex from '@eumentis-cloud/js-validation-regex';

import MUTATION from '../graphql/mutations/newRetainerClientDocumentUploadRequestMutation.graphql';

const FormItem = Form.Item;
const { TextArea } = Input;

class NewRetainerClientDocUploadRequestForm extends Component {
  state = {
    submittingForm: false,
  };

  handleSubmit = (event) => {
    event.preventDefault();
    this.setState({
      submittingForm: true,
    });

    const { form, mutate, retainerClientId } = this.props;
    form.validateFieldsAndScroll((err, values) => {
      if (!err) {
        mutate({ variables: { retainerClientId, ...values } })
          .then(() => {
            this.setState({
              submittingForm: false,
            });
            form.resetFields();
            message.success('Doc upload request!');
          })
          .catch((err1) => {
            this.setState({
              submittingForm: false,
            });
            console.log(err1);
            message.error(err1.message);
          });
      } else {
        this.setState({
          submittingForm: false,
        });
      }
    });
  };

  render() {
    const { submittingForm } = this.state;
    const { form } = this.props;
    const { getFieldDecorator } = form;

    return (
      <Form onSubmit={this.handleSubmit}>
        <FormItem label="Document Title" hasFeedback>
          {getFieldDecorator('title', {
            rules: [{ required: true, message: 'Field is required!' }],
          })(<TextArea disabled={submittingForm} autosize={{ minRows: 1, maxRows: 2 }} />)}
        </FormItem>
        <FormItem label="Description">
          {getFieldDecorator('description')(
            <TextArea disabled={submittingForm} autosize={{ minRows: 3, maxRows: 6 }} />,
          )}
        </FormItem>
        <FormItem label="Filename">
          {getFieldDecorator('filename', {
            rules: [
              { required: true, message: 'Field is required!' },
              { pattern: validationRegex.filename, message: 'Allowed only letters, space & characters: . - _' },
            ],
          })(<Input disabled={submittingForm} required />)}
        </FormItem>
        <FormItem>
          <Button type="primary" htmlType="submit" loading={submittingForm}>
            Submit
          </Button>
        </FormItem>
      </Form>
    );
  }
}

NewRetainerClientDocUploadRequestForm.propTypes = {
  retainerClientId: PropTypes.number.isRequired,
  form: PropTypes.shape({
    getFieldDecorator: PropTypes.func,
    validateFieldsAndScroll: PropTypes.func,
    resetFields: PropTypes.func,
  }).isRequired,
  mutate: PropTypes.func.isRequired,
};

export default compose(
  graphql(MUTATION),
  Form.create(),
)(NewRetainerClientDocUploadRequestForm);



// WEBPACK FOOTER //
// ./src/forms/NewRetainerClientDocUploadRequestForm.jsx